<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="constraint-notifier constraint-notifier-zindex"
	[hidden]="(pendingAcceptance$ | async)?.size < 1 || (isOpen$ | async)"
	[class.idle-animation]="!(isOpen$ | async)"
>
	<div
		class="constraint-notifier-peek clickable-pointer"
		(click)="toggle()"
		automationId="constraintRequestNoty"
	>
		{{ (pendingAcceptance$ | async)?.size }} constraint(s) requested
	</div>
</div>

<div
	class="constraint-notifier constraint-notifier-zindex popup-widthless--blue"
	*ngIf="(isOpen$ | async) && (pendingAcceptance$ | async)?.size > 0"
	[@slideInOut]
>
	<!-- header -->
	<div class="justify-space-between">
		<div class="h3-heading-bold">{{ (pendingAcceptance$ | async)?.size }} constraint(s) requested</div>
		<div>
			<span [hidden]="(pendingAcceptance$ | async)?.size <= 1">
				<span (click)="cycleDown()">
					<i class="material-icons clickable-pointer">chevron_left</i>
				</span>
				<span class="cycle-numbers">
					{{ currentIndex$ | async }} / {{ (pendingAcceptance$ | async)?.size }}
				</span>
				<span (click)="cycleUp()">
					<i class="material-icons clickable-pointer">chevron_right</i>
				</span>
			</span>
		</div>
	</div>

	<!-- content -->
	<div class="explanation-text constraint-notifier-content">
		<div
			class="constraint-notifier-thumbnail"
			[style.background]="
				(currentSelected$ | async)?.view?.assignedProjectMemberRole?.view.color || '#000000'
			"
		></div>
		<div class="constraint-acceptance-title">{{ (currentSelected$ | async)?.view.shortActivityName }}</div>
		<div class="grid-column-start-2">
			Planned Date: {{ (currentSelected$ | async)?.view?.liveFinish || 'N/A' }}
		</div>
		<div class="constraint-notifier-divider grid-column-start-2"></div>
		<div class="grid-column-start-2">
			Requested by:
			{{
				(currentSelected$ | async)?.view?.requestedByProjectMember?.view?.user?.firstName +
					' ' +
					(currentSelected$ | async)?.view?.requestedByProjectMember?.view.user?.lastName
			}}
		</div>
		<div class="grid-column-start-2">Plan: {{ otherPlanName }}</div>
		<div class="grid-column-start-2 location-container">
			<i class="material-icons location-icon">location_on</i>
			{{ (currentSelected$ | async)?.view?.location?.view.name || 'N/A' }}
		</div>
	</div>

	<!-- footer -->
	<div class="justify-space-between">
		<div>
			<button class="legacy-button button-sm--white" (click)="toggle()" automationId="later">Later</button>
		</div>
		<div>
			<button
				class="legacy-button button-sm--white horizontal-spacing-md"
				(click)="handleCustomizeAction()"
				automationId="goToPlan"
			>
				{{ customizeLabelName }}
			</button>
			<button
				class="legacy-button button-sm--blue"
				[disabled]="!isSamePlan"
				(click)="confirmAcceptance()"
				automationId="accept"
			>
				Accept
			</button>
		</div>
	</div>
</div>
